import { render, staticRenderFns } from "./ImportExportRecords.vue?vue&type=template&id=10200356&scoped=true&"
import script from "./ImportExportRecords.vue?vue&type=script&lang=js&"
export * from "./ImportExportRecords.vue?vue&type=script&lang=js&"
import style1 from "./ImportExportRecords.vue?vue&type=style&index=1&id=10200356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10200356",
  null
  
)

export default component.exports